import type { UpdateActionRequest } from 'api/__GENERATED';
import { timeUtility } from 'utility';
import { errorWrapper } from 'utility/error';

import { apiClient } from './api';
import { toAction } from './transformers/toAction';

// Sends an update-action request to Action_Update and returns the updated
// Data.Action. improvementAreaId must be non-null — callers are expected to
// guard before calling this function. startAt/endAt are converted from
// DateItem to ISO strings for the request body.
async function updateAction(args: { tenantId: string; action: Data.Action }) {
  const { tenantId, action } = args;

  const body: UpdateActionRequest = {
    // Caller is responsible for ensuring improvementAreaId is non-null
    improvementAreaId: action.improvementAreaId!,
    title: action.name,
    problemStatement: action.problemStatement,
    solutionProposal: action.solutionProposal,
    definitionOfDone: action.definitionOfDone,
    status: action.status,
    startAt: timeUtility
      .toDate({ type: 'day', ...action.startAt })
      .toISOString(),
    endAt: timeUtility.toDate({ type: 'day', ...action.endAt }).toISOString(),
    priority: action.priority,
    responsibleEmployee: action.responsibleEmployee,
    suggestionIds: action.suggestionIds,
  };

  const apiCall = apiClient.Action_Update(body, {
    params: { tenantId, actionId: action.id },
  });

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to update action',
    },
    onSuccess: (dto) => {
      const updatedAction = toAction(dto);
      return { action: updatedAction };
    },
  });
}

export { updateAction };
